exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-padding{\npadding: 0px\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/timesheets/create-timesheet/create-timesheet.component.css
// module id = ../../../../../src/app/timesheets/create-timesheet/create-timesheet.component.css
// module chunks = main